// CamId is stored in localStorage 
export const GET_CAM_ID = () => {
    if(window.localStorage.getItem('camId'))
        return window.localStorage.getItem('camId');
    else    
        return "";
}
let camId = GET_CAM_ID();

export const ENDPOINT_AUTHENTICATE =            () => `/auth`;

// Traffic Congestion endpoint
export const ENDPOINT_CONGESTION_HISTORY =      (from: number, to: number, interval?: number) => `/congestion-history?interval=${interval}&from=${from}&to=${to}`;

export const ENDPOINT_TURN_COUNT =              () => `/turn-counts`;

// Traffic Details endpoint
export const ENDPOINT_TURN_VIOLATIONS_COUNT =   (from: number, to: number, turnDirection?: string) => {
    return (turnDirection)? `/turn-violation-counts?from=${from}&to=${to}&turn-direction=${turnDirection}`: `/turn-violation-counts?from=${from}&to=${to}` ;
}

// Total Violations endpoint
export const ENDPOINT_VIOLATIONS_HISTORY =      (from: number, to: number, interval?: number) => `/violations-history?interval=${interval}&from=${from}&to=${to}&camId=${camId}`;

// Violations List endpoint
export const ENDPOINT_VIOLATIONS =              (from?: number, to?: number, type?: string[], count?: number, page?: number) => {
    let typeParam = '';

    if (camId === "iskann_7244137221") {
        //@TODO @abdullah remove this site-specific demo only fix
        from = 1609441200000;
    }
    if (type) {
        type.map(function (item) {
            typeParam = typeParam + '&type=' + item
        });
    }
    return `/violations?from=${from}&to=${to}${typeParam}&count=${count}&page=${page}&camId=${camId}`;
};

// Dashboard Updates (Server sent events) endpoint
export const ENDPOINT_DASHBOARD_UPDATES =       () => `/dashboard-updates`;
    



// WEBPACK FOOTER //
// ./src/config/endpoints.ts